var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "System Icon /Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explorer-Desktop@1440px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-Order-Detail_Filled",
    transform: "translate(-1104.000000, -653.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Detail",
    transform: "translate(496.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(456.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(130.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-Icon-/Copy",
    transform: "translate(22.000000, 11.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 L14,9.91666667 L9.916,9.916 L9.91666667,14 L0,14 L0,4.08333333 L4.083,4.083 L4.08333333,0 L14,0 Z M8.16666667,5.83333333 L1.75,5.83333333 L1.75,12.25 L8.16666667,12.25 L8.16666667,5.83333333 Z M12.25,1.75 L5.83333333,1.75 L5.833,4.083 L9.91666667,4.08333333 L9.916,8.166 L12.25,8.16666667 L12.25,1.75 Z",
    id: "Copy",
    fill: "#073C50"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.333264dfcca51342c0817a8e338582ef.svg";
export { ForwardRef as ReactComponent };